import React from 'react';
import { Modal, Button, Progress } from 'antd';
import common from '../../assets/common.js';
import successIcon from '../../images/successicon.svg'
import warningIcon from '../../images/warningicon.svg'
import errorIcon from '../../images/erroricon.svg'
import './index.css';

class UpdateModal extends React.Component {
  constructor(){
    super();
    this.state = {
      modalShow : "update",
      type : "confirm"
    }
  }
  confirm = () => {
    this.setState({ type : "ing" });
  }
  render(){
    const { modalShow, type } = this.state;
    const { modalData, modalType } = this.props;
    let footer = false;
    switch(type){
      case "error":
        footer = false;
        break;
      default:
        footer = <div>
          <Button onClick={ this.props.showModal.bind(this, "") } >取消</Button>
          <Button type="primary" onClick={ this.confirm } >确定</Button>
        </div>
        break;
    }
    return (
      <Modal
        visible={ modalType === modalShow }
        title="提示"
        footer={ footer }
        onCancel={ this.props.showModal.bind(this, "") }
      >
      {
        type === "confirm" && <div className="ing text-center">
          <img src={ warningIcon } alt=""/>
          <div>该项操作需要执行较长时间，期间您将无法进行其他操作，</div>
          <div>您要继续此操作吗？</div>
        </div>
      }
      {
        type === "ing" && <div className="end text-center">
          <img src={ warningIcon } alt=""/>
          <span>正在更新，请不要刷新页面，耐心等待…</span>
        </div>
      }
      {
        type === "success" && <div className="end text-center">
          <img src={ successIcon } alt=""/>
          <div className="mt-18">更新成功</div>
          <Button className="mt-24" onClick={ this.props.showModal.bind(this, "") }>关闭</Button>
        </div>
      }
      {
        type === "error" && <div className="text-center">
          <img src={ errorIcon } alt="" width="80px"/>
          <div className="s">更新出错</div>
          <div className="mt-18 text-left">
            <div>以下门发布/更新出错：</div>
            <div className="content-border mt-8">
              <div>宿舍1号楼大门</div>
              <div>宿舍2号楼大门</div>
              <div>宿舍3号楼大门</div>
            </div>
          </div>
          <Button className="mt-24" onClick={ this.props.showModal.bind(this, "") }>关闭</Button>
        </div>
      }
      </Modal>
    )
  }
}
export default UpdateModal;



// WEBPACK FOOTER //
// ./src/component/manage/updatemodal.js